import { render, staticRenderFns } from "./RouterLink.vue?vue&type=template&id=0968b389&"
import script from "./RouterLink.vue?vue&type=script&lang=js&"
export * from "./RouterLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports